

import { IFilterAniversariantes } from "../ContextReportAniversariantesTypes";
import { FormatDateDayLastMonth } from "src/shared/Utils/FormatDate/FormatDateDayLastMonth";

export const valuesDefaultFilterAniversariantes: IFilterAniversariantes = {
  startDate: FormatDateDayLastMonth().firstDayMonth,
  endDate: FormatDateDayLastMonth().lastDayMonth,
};

